define('models/shared/user/role',['backbone'], function (Backbone) {
    var Role = Backbone.Model.extend({
        initialize: function (options) {
            options = options || {};
            this.RoleID = options.RID;
            this.ParentRoleID = options.PRID;
            this.RoleName = options.RN;
        },
        parse: function (data) {
            var response = {};
            response.RoleID = data.RID;
            response.ParentRoleID = data.PRID;
            response.RoleName = data.RN;
            return response;
        },
    });

    return Role;
});

